import {Icon} from "@fluentui/react";
import {stripDiacritics} from "./WhitespaceMatcher";

export const taskWarning = (item) => {
    if (item.done === null && item.rejected === null && item.in_progress === null) {
        const diff = new Date().getTime() - new Date(item.created).getTime();
        const days = Math.ceil(diff / (1000 * 3600 * 24));
        if (days > 14) {
            return (<span style={{'color': 'purple'}}><Icon iconName='Cancel'/>{item.created}</span>)
        }
        else if (days > 9) {
            return (<span style={{'color': 'red'}}><Icon iconName='Warning12'/>{item.created}</span>)
        } else if (days > 4) {
            return (<span style={{'color': 'orange'}}><Icon iconName='Warning12'/>{item.created}</span>)
        }
    }
    return item.created;
}

export const formatComments = (item) => { return {onRenderContent: () => {
        if (item.comments === null) {
            return null;
        }
        const comment = item.comments.split('###').map((item) => (<li>{item}</li>));
        return (
            <ol style={{ margin: 15, padding: 0 }}>
                {comment}
            </ol>)
}}}

export const sortColumns = (columns, sort, setColumns, tasks, setTasks) => {
    const newColumns = columns.slice();
    const currColumn = newColumns.filter(currCol => sort.key === currCol.key)[0];
    newColumns.forEach((newCol) => {
        if (newCol === currColumn) {
            currColumn.isSortedDescending = !currColumn.isSortedDescending;
            currColumn.isSorted = true;
        } else {
            newCol.isSorted = false;
            newCol.isSortedDescending = true;
        }
    });
    setColumns(newColumns);
    const sorted = tasks.slice(0).sort((a, b) => {
        let valueA = a[sort.key];
        let valueB = b[sort.key];
        if (!isNaN(parseFloat(valueA))) {
            valueA = parseFloat(a[sort.key]);
        }
        if (!isNaN(parseFloat(valueB))) {
            valueB = parseFloat(b[sort.key]);
        }
        return ((currColumn.isSortedDescending ? valueA < valueB : valueA > valueB) ? 1 : -1)
    });
    setTasks(sorted);
}

export const searchByText = (data, search) => {
    const searchWords = stripDiacritics(search).toLowerCase().split(' ');
    return data.filter(item =>
        searchWords.every(word =>
            stripDiacritics(item.venture).toLowerCase().includes(word) ||
            stripDiacritics(item.project).toLowerCase().includes(word)
        )
    );
    return data
};

export function filterTasks(tasks, userFilter, user, searchbox, setFilteredTasks) {
    let filteredTasksTemp = [...tasks]
    switch (userFilter) {
        case 'me':
            filteredTasksTemp = tasks.filter(item => item.username === user.username)
            break;
        case 'unassigned':
            filteredTasksTemp = tasks.filter(item => item.assigned_to === null)
            break;
    }
    if (searchbox.length > 1) {
        filteredTasksTemp = searchByText(filteredTasksTemp, searchbox)
    }

    setFilteredTasks(filteredTasksTemp)
}

export function modifyTask(id, action, payload, user, setRefresh, method = 'POST') {
    const abortController = new AbortController();
    async function processTask() {
        await fetch(`/api/task/${id}/${action}`, {
            method: method,
            signal: abortController.signal,
            body: JSON.stringify(payload),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                setRefresh(prev => prev + 1);
            })
            .catch(err => {
                console.log(err)
            })
    }
    processTask();
    return () => abortController.abort();
}